<template>
  <div
    class="pdf-body1"
    :style="{ 'padding-bottom': showagr ? '160px' : '65px' }"
  >
 
  <iframe id="pdfIframe" v-if="pdfUrl" width="100%" height="100%" :src="'/static/pdfjs/web/viewer.html?url='+pdfUrl"></iframe>


    <div class="pdf-footer" v-if="!isLoading">
      <div v-if="showagr" class="pdf-tip">
        内容をご理解いただけましたら、<br />
        「同意する」にチェックを入れてください。
      </div>

      <div v-if="showagr" @click="handleCheck" class="confirm-btn">
      
            <img
              :src="
                consent
                  ? require('@/assets/img/checkbox_t.svg')
                  : require('@/assets/img/checkbox_f.svg')
              "
            />
          <span class="text">同意</span>
      </div>

      <div
        class="bnt-by"
      >
         <button class="download-btn" @click="download">ダウンロード</button>
          <button @click="goback">閉じる</button>
      </div>
    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf';
import Moment from 'moment'
import CMapReaderFactory from 'vue-pdf-signature/src/CMapReaderFactory.js';
export default {
  components: {
    pdf
  },
  data() {
    return {
      pdfUrl: '',
      numPages: null,
      showagr: null,
      consent: false,
      pdfObj: {},
      isLoading: true
    };
  },
  computed: {
    pdfSrc() {
      //处理pdfUrl返回
      let src = pdf.createLoadingTask({
        url: this.pdfUrl,
        cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.8.335/cmaps/',
        cMapPacked: true,
        CMapReaderFactory
      });
      return src;
    }
  },
  methods: {
    goback() {
      if (this.showagr && this.consent) {
        this.$emit('close', this.consent, this.pdfObj);
      } else {
        this.$emit('close', this.consent, this.pdfObj);
      }
      this.pdfUrl = '';
      this.numPages = null;
      this.showagr = null;
      this.pdfObj = {};
      this.consent = false;
    },
    getNumPages() {
      let obj = {
        url: this.pdfUrl,
        cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.8.335/cmaps/',
        cMapPacked: true,
        CMapReaderFactory
      };
      let loadingTask = pdf.createLoadingTask(obj);
      this.isLoading = true;
      this.$f7.preloader.show();
      loadingTask.promise.then((pdf) => {
          this.numPages = pdf.numPages;
          this.$emit('read', this.pdfObj); // emit read event when loading successed
          if(this.numPages > 5){
            setTimeout(()=>{
              this.isLoading = false;
              this.$f7.preloader.hide();
            },3000)
          }else{
            this.isLoading = false;
            this.$f7.preloader.hide();
          }
        }).catch((err) => {

        this.$f7.preloader.hide();
          this.isLoading = false;
          this.$cErrorDialog({
            title: '',
            left: 'cancel',
            right: 'OK',
            content: '読み込みに失敗しました',
            cancelBtn: false //这个是启用取消按钮，
          });
        });
    },

      download(){

        let PDFName = this.pdfObj.DOCUMENT_NAME
        let date =  Moment(this.pdfObj.BASE_D).format('YYYYMMDD')

        sessionStorage.setItem('PDFName',PDFName + '_' + date)

        let download = document.getElementById('pdfIframe').contentWindow.document.getElementById('secondaryDownload')
        if(download) download.click()
      },
      testPDFValid() {
        let obj={
          url: decodeURIComponent(this.pdfUrl),
            //引入pdf.js字体，templ
          cMapPacked: true,
          CMapReaderFactory,
        }
        // console.log(obj)
        let LoadingTask = pdf.createLoadingTask(obj);
        this.isLoading=true;
        this.$f7.preloader.show();
        LoadingTask.promise.then(pdf => {
         this.$emit('read', this.pdfObj);
            this.isLoading=false;
            this.$f7.preloader.hide();
        }).catch(err => {

          
           this.isLoading=false;
          this.$f7.preloader.hide();
            this.commonJs.showAlert('読み込みに失敗しました','','','',()=>{
              this.$emit('close',false,{})
            })
        })


      },

    pdf_ini(obj, pdfObj) {
      this.consent = false;
      //是否需要同意按钮
      this.showagr = obj.agree != 0 ? true : false;
      this.pdfUrl = obj.path;
      //如果有同意按钮 isAgree
      if (obj.agree) {
        this.consent = obj.isAgree;
      }
      // 传过来的pdf 信息
      this.pdfObj = pdfObj;
      this.testPDFValid();
      // this.getNumPages();
    },
    handleCheck() {
      this.consent = !this.consent;
    }
  }
};
</script>

<style lang="less" scoped>


#pdfIframe{
  margin: 0px;
  border: 0px;
}

.pdf-body1 {
  overflow: hidden;
  height: 100%;
  background:  #fff;
  padding-bottom: 0.6rem;
  position: relative;
  .confirm-btn {
      width: 100px;
      margin: auto;
      display: flex;
      justify-content: center;
      margin: 5px auto 10px;
    img{
      height: 0.24rem;
    }
    .text {
      margin-left: 0.1rem;
      height: 0.24rem;
      font-size: 0.16rem;
    }
  }
}
.pdf-footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background: white;
  box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.3);
    padding: 10px 20px;
}
.pdf-tip {
  font-size: 0.16rem;
}
.bnt-by {
  display: flex;
  align-items: center;
  justify-content: space-between;

  button {
    background: #0a89c7;
    border: none;
    border-radius: 0.1rem;
    color: #fff;
    font-size: 0.18rem;
    width: 50%;
    padding:8px 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: 1px solid transparent;
      width: calc(50% - 20px);
    cursor: pointer;
  }
  .download-btn{
      color: #0A89C7;
      border: 1px solid #0A89C7;
      background-color: transparent;
      cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pdf/aggree-pdf.vue